<template>
  <ValidationProvider
    v-slot="{ failedRules, valid, touched }"
    :name="name"
    :rules="rules"
    :class="{ 'has-error': (fields[name] || {}).invalid && (fields[name] || {}).touched }"
    slim
  >
    <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
    <input
      v-model="model"
      v-tooltip="
        valid || !touched || disabled
          ? null
          : {
              trigger: 'manual',
              show: true,
              content: Object.values(failedRules)[0],
              classes: ['has-error'],
            }
      "
      :type="type"
      :class="classObj(valid || !touched)"
      :placeholder="placeholder"
      :pattern="pattern"
      :disabled="disabled"
    />
  </ValidationProvider>
</template>

<script>
export default {
  name: 'InputValidated',
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    fields: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    rules: {
      type: [String, Object],
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    classes: {
      type: Object,
      required: false,
      default: () => {},
    },
    pattern: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || '';
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    classObj(valid) {
      return { 'form-control': true, ...this.classes, 'has-error': !valid };
    },
  },
};
</script>

<style>
.has-error .tooltip-inner {
  background-color: var(--fail);
}
.has-error .tooltip-arrow {
  border-color: var(--fail);
}
.form-control.has-error {
  border-color: var(--fail);
}
</style>
